// Module
var code = "<div ng-show=\"$ctrl.permit\" class=\"{{$ctrl.class}}\" ng-transclude></div>";
// Exports
module.exports = code;